/** A selector which only ever matches on IE.
 *
 * Can be used to provide hacks for unsupported CSS in IE11.
 */
export const ieOnly = `@media all and (-ms-high-contrast:none)`;
